var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "v-icon__svg",
      attrs: { width: "24px", height: "24px", viewBox: "0 0 24 24" },
    },
    [
      _c(
        "g",
        {
          attrs: {
            id: "camera-icon",
            transform: "translate(2.000000, 3.000000)",
            "fill-rule": "nonzero",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M2,2 L5,2 L7,0 L13,0 L15,2 L18,2 C19.1045695,2 20,2.8954305 20,4 L20,16 C20,17.1045695 19.1045695,18 18,18 L2,18 C0.8954305,18 0,17.1045695 0,16 L0,4 C0,2.8954305 0.8954305,2 2,2 M10,5 C7.23857625,5 5,7.23857625 5,10 C5,12.7614237 7.23857625,15 10,15 C12.7614237,15 15,12.7614237 15,10 C15,7.23857625 12.7614237,5 10,5 M10,7 C11.6568542,7 13,8.34314575 13,10 C13,11.6568542 11.6568542,13 10,13 C8.34314575,13 7,11.6568542 7,10 C7,8.34314575 8.34314575,7 10,7 Z",
              id: "Shape",
            },
          }),
        ]
      ),
      _c(
        "g",
        {
          attrs: {
            id: "pose-overlay",
            transform: "translate(12.000000, 12.000000)",
          },
        },
        [
          _c("circle", {
            attrs: {
              id: "overlay-background",
              fill: "#FFFFFF",
              cx: "6",
              cy: "6",
              r: "6",
            },
          }),
          _c("path", {
            attrs: {
              d: "M9.86370331,3.46472382 C9.93517421,3.73145687 9.77688297,4.00562535 9.51014991,4.07709626 L6.97039979,4.75751976 C6.98973624,4.83515523 7,4.916379 7,5 L6.99999659,6.83765289 C7.05306985,6.86178801 7.10279044,6.89568366 7.14644661,6.93933983 L8.56066017,8.35355339 C8.64744335,8.44033657 8.69565622,8.55108425 8.7052988,8.66449467 L8.7052988,8.83550533 C8.69565622,8.94891575 8.64744335,9.05966343 8.56066017,9.14644661 L7.14644661,10.5606602 C6.95118446,10.7559223 6.63460197,10.7559223 6.43933983,10.5606602 C6.24407768,10.365398 6.24407768,10.0488155 6.43933983,9.85355339 L7.54289322,8.75 L6.59615065,7.80295021 C6.42968294,7.92674675 6.22339608,8 6,8 C5.88859335,8 5.78144172,7.98178211 5.68136169,7.94816293 C5.65922872,8.02008481 5.61851562,8.08859116 5.56066017,8.14644661 L4.14644661,9.56066017 C4.05966343,9.64744335 3.94891575,9.69565622 3.83550533,9.7052988 L3.66449467,9.7052988 C3.55108425,9.69565622 3.44033657,9.64744335 3.35355339,9.56066017 L1.93933983,8.14644661 C1.74407768,7.95118446 1.74407768,7.63460197 1.93933983,7.43933983 C2.13460197,7.24407768 2.45118446,7.24407768 2.64644661,7.43933983 L3.74989322,8.543 L4.85355339,7.43933983 C4.91140884,7.38148438 4.97991519,7.34077128 5.05276078,7.31720054 C5.01833754,7.21926086 5,7.11177191 5,7 L4.99989322,5.285 L2.74866913,5.88882957 C2.48193608,5.96030048 2.2077676,5.80200923 2.13629669,5.53527618 C2.06482579,5.26854313 2.22311703,4.99437465 2.48985009,4.92290374 L9.25133087,3.11117043 C9.51806392,3.03969952 9.7922324,3.19799077 9.86370331,3.46472382 Z M6,1.5 C6.55228475,1.5 7,1.94771525 7,2.5 C7,3.05228475 6.55228475,3.5 6,3.5 C5.44771525,3.5 5,3.05228475 5,2.5 C5,1.94771525 5.44771525,1.5 6,1.5 Z",
              id: "pose",
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }